module.exports = __webpack_public_path__ + "img/3-low.27ba9617.jpg";